import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessagePopUp from "../ErrorMessagePopUp/ErrorMessagePopUp";

const ErrorMessage = props => <ErrorMessagePopUp {...props} />;

ErrorMessage.propTypes = {
  showErrorMessage: PropTypes.bool,
  hideGlobalErrorMessage: PropTypes.func,
  message: PropTypes.string,
  callback: PropTypes.func,
};

export default ErrorMessage;
